import React from 'react';
import {
  Badge,
  Button,
  Popconfirm,
  Tooltip,
} from 'antd';
import {
  AudioMutedOutlined,
  AudioOutlined,
  MessageOutlined,
  PhoneFilled,
  VideoCameraOutlined,
} from '@ant-design/icons';

// Botão nativo desabilitado não dispara o Tooltip: o span em volta recebe o hover.
function ControlButton({
  hint,
  className,
  disabled,
  onClick,
  children,
}) {
  return (
    <Tooltip title={hint}>
      <span className="tmd-ctrl-wrap">
        <button type="button" className={className} disabled={disabled} onClick={onClick}>
          {children}
        </button>
      </span>
    </Tooltip>
  );
}

function ControlBar({
  micMuted,
  camOff,
  noAudioDevices,
  noVideoDevices,
  mediaReady,
  chatOpen,
  unread,
  ending,
  connected,
  onToggleMic,
  onToggleCam,
  onToggleChat,
  onEnd,
}) {
  return (
    <div className="tmd-controls">
      <ControlButton
        hint={noAudioDevices ? 'Nenhum microfone detectado' : null}
        className={`tmd-ctrl${micMuted || noAudioDevices ? ' tmd-ctrl-off' : ''}`}
        disabled={noAudioDevices || !mediaReady || ending}
        onClick={onToggleMic}
      >
        {micMuted || noAudioDevices ? <AudioMutedOutlined /> : <AudioOutlined />}
        <span className="tmd-ctrl-label">{micMuted ? 'Sem áudio' : 'Microfone'}</span>
      </ControlButton>

      <ControlButton
        hint={noVideoDevices ? 'Nenhuma câmera detectada' : null}
        className={`tmd-ctrl${camOff || noVideoDevices ? ' tmd-ctrl-off' : ''}`}
        disabled={noVideoDevices || !mediaReady || ending}
        onClick={onToggleCam}
      >
        <VideoCameraOutlined />
        <span className="tmd-ctrl-label">{camOff ? 'Câmera off' : 'Câmera'}</span>
      </ControlButton>

      <Badge count={unread} size="small" offset={[-6, 4]}>
        <button
          type="button"
          className={`tmd-ctrl${chatOpen ? ' tmd-ctrl-active' : ''}`}
          aria-pressed={chatOpen}
          onClick={onToggleChat}
        >
          <MessageOutlined />
          <span className="tmd-ctrl-label">Chat</span>
        </button>
      </Badge>

      <Popconfirm
        title="Encerrar a teleconsulta?"
        description={connected
          ? 'A chamada será encerrada para você e para o paciente.'
          : 'A sala será fechada.'}
        okText="Encerrar"
        okButtonProps={{ danger: true }}
        cancelText="Voltar"
        placement="top"
        disabled={ending}
        onConfirm={onEnd}
      >
        <Button
          className="tmd-ctrl-leave"
          type="primary"
          danger
          icon={<PhoneFilled rotate={225} />}
          loading={ending}
        >
          <span className="tmd-ctrl-label">Encerrar</span>
        </Button>
      </Popconfirm>
    </div>
  );
}

export default ControlBar;
